import { getCookie } from "services/cookies-service";
import { M_SOURCE } from "constants/cookies";
export const resolveAshbyUtmData = ()=>{
    if (typeof window !== "undefined") {
        const fromUrl = new URLSearchParams(window.location.search).get("utm_source");
        if (fromUrl) return {
            utm_source: fromUrl
        };
    }
    const fromCookie = getCookie(M_SOURCE);
    if (fromCookie) return {
        utm_source: fromCookie
    };
    return {};
};
